import { CONSENT_GEO_KEY } from './consent-geo-key';

export function readGeoConsentRequired(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  try {
    return localStorage.getItem(CONSENT_GEO_KEY) !== '0';
  } catch {
    return true;
  }
}
